import script from "./FordRedisAdminPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FordRedisAdminPanel.vue?vue&type=script&setup=true&lang=js"

import "./FordRedisAdminPanel.vue?vue&type=style&index=0&id=7baffcf4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7baffcf4"]])

export default __exports__